import { combineReducers } from '@reduxjs/toolkit';
import auth from './auth';
import onboarding from './onboarding';
import snackbar from './snackBar';
import employeeDetails from './employeeDetails';
import chat from './chat';
import pagination from './component/pagination';
import notifications from './notifications';
import fund from './fund';
import navigation from './navigation';
import configuration from './configuration';


const rootReducer = combineReducers({
  auth,
  onboarding,
  snackbar,
  employeeDetails,
  chat,
  pagination,
  notifications,
  fund,
  navigation,
  configuration
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
